import { useSignedUrl } from "@/lib/media/useSignedUrl";

interface SignedAudioProps extends Omit<React.AudioHTMLAttributes<HTMLAudioElement>, "src"> {
  src: string | null | undefined;
}

/** Drop-in <audio> replacement that transparently resolves signed storage URLs. */
const SignedAudio = ({ src, ...rest }: SignedAudioProps) => {
  const signedSrc = useSignedUrl(src);
  if (!signedSrc) return null;
  return <audio src={signedSrc} {...rest} />;
};

export default SignedAudio;
